import { r as registerInstance, c as createEvent, h, H as Host, g as getElement } from './index-8f7fb048.js';
import { s as supportedDropdownTriggers } from './dropdown-bffc18e2.js';
import { g as getNamespacedTagFor } from './index-739b155e.js';

const marketButtonDropdownCss = ":host{display:inline-block}svg{fill:transparent}";

/**
 * Type guard to check if the supported trigger element is a `market-button`
 */
function isMarketButton(el) {
  return el.tagName.toLowerCase() === getNamespacedTagFor('market-button');
}
const MarketButtonDropdown = class {
  constructor(hostRef) {
    registerInstance(this, hostRef);
    this.marketButtonDropdownOpened = createEvent(this, "marketButtonDropdownOpened", 7);
    this.marketButtonDropdownClosed = createEvent(this, "marketButtonDropdownClosed", 7);
    this.interaction = 'click';
    this.disabled = false;
    this.noCaret = false;
    this.popoverPlacement = 'bottom-end';
    this.persistListSelections = false;
    this.dropdownIsActive = false;
  }
  dropdownOpenedEventHandler() {
    this.dropdownIsActive = true;
    this.setCaret();
    this.marketButtonDropdownOpened.emit();
  }
  dropdownClosedEventHandler() {
    this.dropdownIsActive = false;
    this.setCaret();
    this.marketButtonDropdownClosed.emit();
  }
  syncTriggerDisabledState() {
    if (this.slottedButton) {
      this.slottedButton.disabled = this.disabled;
    }
  }
  setCaret() {
    if (this.noCaret || !isMarketButton(this.slottedButton)) {
      return;
    }
    if (this.dropdownIsActive) {
      this.slottedButton.caret = 'up';
    }
    else {
      this.slottedButton.caret = 'down';
    }
  }
  registerTrigger() {
    this.slottedButton = this.el.querySelector(supportedDropdownTriggers.join(','));
    this.syncTriggerDisabledState();
    this.setCaret();
  }
  componentWillRender() {
    const markeListTagName = getNamespacedTagFor('market-list');
    const list = this.el.querySelector(markeListTagName);
    if (list) {
      // We set this here even though market-popover also sets it,
      // because the slotted market-list's componentWillLoad hook
      // will fire before market-popover's, and we need it to be set
      // before the row processing that happens in that hook.
      list.interactive = true;
      list.transient = !this.persistListSelections;
    }
  }
  render() {
    const MarketDropdownTagName = getNamespacedTagFor('market-dropdown');
    const MarketPopoverTagName = getNamespacedTagFor('market-popover');
    return (h(Host, { class: "market-button-dropdown", "aria-expanded": this.dropdownIsActive }, h(MarketDropdownTagName, { interaction: this.interaction, "popover-placement": this.popoverPlacement, disabled: this.disabled }, h("slot", { name: "trigger", slot: "trigger", onSlotchange: () => this.registerTrigger() }), h(MarketPopoverTagName, { slot: "popover", part: "popover" }, h("slot", { name: "content" })))));
  }
  get el() { return getElement(this); }
  static get watchers() { return {
    "disabled": ["syncTriggerDisabledState"]
  }; }
};
MarketButtonDropdown.style = marketButtonDropdownCss;

export { MarketButtonDropdown as market_button_dropdown };
